var map = {
	"./arrow-down-black.svg": 9391,
	"./arrow-left-black.svg": 4664,
	"./arrow-left-white-shadow-desktop.svg": 9092,
	"./arrow-left-white-shadow-mobile.svg": 4522,
	"./arrow-left.svg": 3130,
	"./arrow-right-black.svg": 3935,
	"./arrow-right-white-shadow-desktop.svg": 6541,
	"./arrow-right-white-shadow-mobile.svg": 8665,
	"./arrow-right.svg": 6065,
	"./arrow-up-white-shadow-desktop.svg": 392,
	"./arrow-up.svg": 3870,
	"./download.svg": 7261,
	"./menu-button.svg": 1721,
	"./menu-close.svg": 5315
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 703;